<template>
  <div v-if="isInitial">
    <div class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <div v-if="ssInfo.komikomi_flag === 1">
            <div class="section fixed-bottom-wrapper white-panel pt28 pb184 mb2p">
              <p class="mb8 mt8">
                <img src="/lib/images/img_CCTop_banner_syaken.png" class="w100p" alt="コミっと車検">
              </p>

                <ul class="flex stretch ul-col2">
                  <li>
                    <button v-on:click='InspectionDetailPage(ssInfo, profileInfo, nativeData, detail, versionData)' class="button button-gray w100p pd12 radius200 fs14 mb16 pb12 pt12">詳しく見る</button>
                  </li>
                  <li>
                    <button v-on:click='nextPage(tsId, ssInfo, profileInfo, nativeData, versionData)' class="button button-green w100p pd12 radius200 fs14 mb16 pb12 pt12">無料で3分見積り</button>
                  </li>
                </ul>
                <div class="bg-gray1 pd12">
                  <p class="mb0 fs13">お客様のお気に入り店舗での受付となります。
                    外車や年式の古い車両はご利用いただけません。
                    ご利用の詳細は<a id="aboutConditions" v-on:click='modalOpen($event)'>こちら</a>をご覧ください。<br>
                    特定商取引にかかわる表記については<a href="#" v-on:click="toAgreement()">こちら</a></p>
                </div>
            </div>
          </div>
          <div v-else>
            <div class="section white-panel pt28 pb24 mb2p">
              <p class="fs16 font-weight-bold mb4p">お気に入り店舗を「コミっと車検」に対応しているSSに変更してください</p>
              <p class="fs14">お客様のお気に入り店舗では「コミっと車検」の受付をしておりません。<br>「コミっと車検」をご利用の場合は、取り扱っているSSをお気に入り店舗に変更してください。</p>
              <div class="border-solid-gray radius16 pd20 mt20 mb5p">
                <div v-if="ssInfo.length !== 0">
                  <p class="fs14 mb4">ご登録中のお気に入り店舗</p>
                  <h2 class="fs16 font-weight-bold mb20">{{ ssInfo.ss_name }}</h2>
                </div>
                <div v-else>
                  <p class="fs14 mb4">お気に入り店舗が登録されていません</p>
                </div>
                <a v-on:click='appChangeMySs()' style="text-decoration: none;"><button class="button fs16 mb8 w80p">お気に入り店舗を変更</button></a>
              </div>
              <button v-on:click='InspectionDetailPage(ssInfo, profileInfo, nativeData, detail, versionData)' class="button button-gray w100p pd12 radius200 fs14 mb16 pb12 pt12">お気に入り店舗を変更せずに車検詳細を見る</button>
            </div>
          </div>

        </article>
      </div>
      <div class="modal_overlay">
        <div class="modal_container">
          <div class="modal_body radius8 pd24 mt8p mb8p">
            <div v-if="aboutConditions">
              <h2 class="fs18 mb8">対象車両の条件</h2>
              <p class="fs14 mb16">・自家用の乗用車（事業用や貨物車両は除く）<br>
                ・普通/軽/小型（大型特殊車両は除く）<br>
                ・国産の8メーカー（外車やその他メーカーは除く）<br>
                －トヨタ、ホンダ、日産、ダイハツ、スズキ、三菱、マツダ、スバル<br>
                ・初度登録年月が車検実施日から遡って20年未満<br>
                ・走行距離が20万km以下
              </p>
              <h2 class="fs18 mb8">ご利用の注意</h2>
              <p class="fs14 mb16">・予約は1端末につき1台まで可能です。2台目以降は車検完了後または別の端末からご予約ください。<br>
                ・機種変更や端末紛失、再インストールによりご予約情報がアプリから確認できなくなった場合は、ご予約のSSまで電話でお問い合わせください。</p>
            </div>
            <div v-if="aboutInspected">
              <p class="fs14 mb16">機種変更や端末紛失の際は、<br>
                車検をご予約のSSまで電話にてご連絡下さい。</p>
            </div>
            <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>
    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import Agreement from '@/views/v3/Agreement.vue'
import { useTsIdStore } from '@/store/tsId'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'
import { useInspectionDetailStore } from '@/store/inspectionDetail'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      modalActive: false,
      aboutConditions: false,
      aboutInspected: false,
      currentState: IS_INITIAL
    }
  },
  methods: {
    modalOpen (about) {
      window.modalHeight = window.pageYOffset
      window.scrollTo(0, 0)
      this.modalActive = true
      if (about.target.id === 'aboutConditions') {
        this.aboutConditions = true
        this.nativePVset('SHAKEN_TAISHO')
        // [eventTrack] カーケアTOP 車検対象車種 タップ
        this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
      } else if (about.target.id === 'aboutInspected') {
        this.aboutInspected = true
      }
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
      this.aboutConditions = false
      this.aboutInspected = false
    },
    appChangeMySs () {
      // 戻るボタンを非活性にする
      this.appDisplayBack(false)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
      // [eventTrack] カーケアTOP マイSS変更 タップ
      this.nativeEVENTSet('ShakenButton', 'MOVED_SSSENTAKU', 'TAP')
    },
    eventTrackStartInspection () {
      // [eventTrack] カーケアTOP 車検見積もり タップ
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_MITSUMORI', 'TAP')
    },
    toInitial () {
      this.currentState = IS_INITIAL
      this.appDisplayBack(true)
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.appDisplayBack(true)
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackInspectionDetailPage () {
      // [eventTrack] カーケアTOP 詳しく見る タップ
      this.nativeEVENTSet('ShakenButton', 'MOVED_INSPECTION_DETAIL', 'TAP')
    },
    InspectionDetailPage (ssInfo, profileInfo, nativeData, detail, versionData) {
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const inspectionDetailStore = useInspectionDetailStore()
      inspectionDetailStore.detail = detail
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.eventTrackInspectionDetailPage()
      this.$router.push({ name: 'InspectionDetailV3' })
    },
    nextPage (tsId, ssInfo, profileInfo, nativeData, versionData) {
      this.eventTrackStartInspection()

      const tsIdStore = useTsIdStore()
      tsIdStore.tsId = tsId
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.$router.push({ name: 'CarV3' })
    }
  },
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  async mounted () {
  },
  components: {
    Agreement
  },
  props: [
    'car',
    'ssInfo',
    'profileInfo',
    'nativeData',
    'versionData',
    'tsId',
    'detail'
  ]
}

</script>
